import { gql } from '@apollo/client'
import { ApolloQueryResult } from '@apollo/client/core'

export type PaymentTypeAvailabilityResult = {
  paymentTypeAvailability: boolean
}
export type PaymentTypeAvailabilityResponse = ApolloQueryResult<PaymentTypeAvailabilityResult>

export const checkPaymentTypeAvailability = gql`
  query CheckPaymentTypeAvailability($typeId: Int!) {
    paymentTypeAvailability(typeID: $typeId)
  }
`
